import {useMutation} from "@tanstack/vue-query";
import axios from "axios";
import {saveCurrentStep} from "@/composables/ai-onboarding/useSteps";
import SweetToast from "@/SweetToast";
import {useStore} from "vuex";
import {computed} from "vue";

const useCompleteOnboarding = () => {
  const store = useStore();

  const user = computed(() => store.getters['user/user']);

  const completeOnboardingMutation = useMutation({
    mutationFn: async () => {
      await axios.post('/ajax/v2/ai-onboarding/keywords/track');
      saveCurrentStep({key: 'completed'});
    },
    onSuccess: () => {
      window.mixpanel('Onboarding: Complete Onboarding', {
        website_id: user.value?.active_website?.id,
      });

      SweetToast.fire({
        icon: "success",
        title: 'Onboarding complete',
      });

      window.location.href = '/dash';
    },
    onError: ({response}) => {
      if (response.status === 400) {
        SweetToast.fire({
          icon: 'error',
          title: response.data.message,
        });
      }

      throw new Error('Something went wrong');
    },
  });

  return {
    completeOnboardingMutation,
  };
};

export default useCompleteOnboarding;